
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { CustomTooltip } from './CustomTooltip';
import { PerformanceChartProps } from './types';
import { formatNumber } from './utils';

export const PerformanceChart = ({ data, dataKey, color, title }: PerformanceChartProps) => (
  <div className="bg-muted/50 dark:bg-muted/20 p-4 rounded-lg">
    <h5 className="text-sm font-medium mb-2 text-muted-foreground">{title}</h5>
    <div className="h-[150px]">
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={data} margin={{ top: 5, right: 5, bottom: 5, left: 5 }}>
          <CartesianGrid strokeDasharray="3 3" className="stroke-border" />
          <XAxis dataKey="day" tick={{ fontSize: 12 }} />
          <YAxis tickFormatter={formatNumber} tick={{ fontSize: 12 }} />
          <Tooltip content={(props) => 
            <CustomTooltip {...props} metric={title} color={color} />
          } />
          <Line
            type="monotone"
            dataKey={dataKey}
            stroke={color}
            strokeWidth={2}
            dot={false}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  </div>
);
